import { render, staticRenderFns } from "./examTicket.vue?vue&type=template&id=235166e3&scoped=true&"
import script from "./examTicket.vue?vue&type=script&lang=js&"
export * from "./examTicket.vue?vue&type=script&lang=js&"
import style0 from "./examTicket.vue?vue&type=style&index=0&id=235166e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235166e3",
  null
  
)

export default component.exports